import React from 'react'
import styled from 'styled-components'
import banner from '../assets/images/banner-servicios.jpg'

const Container = styled.div`
  background-image: url('${banner}');
  padding: 100px;
  margin-bottom: 20px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  .float {
    position: fixed;
    width: 60px;
    height: 60px;
    bottom: 15px;
    right: 30px;
    background-color: #25d366;
    color: #FFF;
    border-radius: 50px;
    text-align: center;
    font-size: 40px;
    box-shadow: 2px 2px 3px #999;
    z-index: 100;
  }
  .float:hover {
    text-decoration: none;
    color: #25d366;
    background-color: #fff;
  }

  .my-float {
    margin-top: 11px;
  }
`

const Bottom = () => {
  return (
    <Container>
      <a href="https://api.whatsapp.com/send?phone=593991157734" className="float" target="_blank">
        <i className="fa fa-whatsapp my-float"></i>
      </a>
    </Container>
  )
}
export default Bottom
